import { useLayoutEffect, useRef } from 'react';

export const useResize = (element: HTMLSpanElement, handler: ResizeObserverCallback) => {
  const observer = useRef(null);

  useLayoutEffect(() => {
    if (!observer.current) {
      observer.current = new ResizeObserver(handler);
    }

    if (element) {
      observer.current.observe(element);
    }

    return () => {
      observer.current.disconnect();
      observer.current = null;
    };
  }, [element, observer, handler]);
};
